__turbopack_context__.v({
  "actionIconRoot": "k52KXq_actionIconRoot",
  "buttonRoot": "k52KXq_buttonRoot",
  "control": "k52KXq_control",
  "loading": "k52KXq_loading",
});
